
/*
Author: Shivakumar
Date: 04/12//2019
Implementation: Mark UnMark Favourite Organisations
search_string: PL-1959
*/
/*
Author: Srinivas P
Date: 11/12/2019
Implementation: sign-out popup is shown on hover of userImage
search_string: PL-2277
*/
<template>
  <div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="waveWrapper waveAnimation">
      <div class="waveWrapperInner bgTop">
        <div class="wave waveTop"></div>
      </div>
      <div class="waveWrapperInner bgMiddle">
        <div class="wave waveMiddle"></div>
      </div>
      <div class="waveWrapperInner bgBottom">
        <div class="wave waveBottom"></div>
      </div>
    </div>
    <div class="welcomeScreen">
      <div class="app-name">
        <a href>
          <span class="logo-name">Pay</span>lief
        </a>
        <div class="by-teamlease">By TeamLease</div>
      </div>
      <div class="addNew" @click="onAddNewOrganisationClick()" :disabled="this.role==='SUPERADMIN' ? false : true ">
        <a href="javascript:void(0)" class="addNewOrg">
          <i class="material-icons add">add</i>Add New Organisation
        </a>
      </div>
      <div class="signoutemp ">
        <!-- start of PL-2277 -->
        <img src="@/assets/pic-placeholder-copy-15.svg" />
        <div class="entity-container paddingbottom">
          <div class="entity-list">
            <img src="@/assets/emplogopic.svg" />
            <div class="emp-details">
              <span>{{name}}</span>
              <br />
              <span>{{email}}</span>
              <br />
              <div class="permission-text" v-if="ifSuperAdmin" @click="permissionAcessFun()">Permission Access</div>
            </div>
          </div>
          <!-- <div class="signoutdiv" v-if="true">
            <div class="btn-settings disabledMode" @click="goToSignUp()">Add Admin Account</div>
          </div> -->
          <div class="signoutdiv">
            <div class="btn-settings disabledMode" v-if="ifSuperAdmin" @click="goToSignUp()">Add Admin Account</div>
            <div class="btn-settings" v-if="ifSuperAdmin" @click="goToUserAccount()">Create User Account</div>
            <div class="divider" v-if="false"></div>
            <div class="btn-signout" @click="signout()">Signout</div>
          </div>
        </div>
        <!-- end of PL-2277 -->
      </div>
    </div>
    <div class="margin_space" v-show="allOrganizationList">
      <div class="allOrganizations animated fadeInUp">
        <tl-header type="h1">
          <div>Your Organisations</div>
        </tl-header>
        <tl-search
          @change="filterOrg($event)"
          autocomplete="off"
          :placeholder="'Search Organizations'"
        />
        <ul class="orgDetails">
          <li class="searchList" v-for="(obj,index) of filterOrgsData" :key="index">
            <span class="viewAllImg" @click="searchOrgNavigation(obj)">
              <img src="@/assets/org.svg" v-if="!obj.logoURL" class="searchOrgimg img-fluid" />
              <img :src="obj.logoURL" v-if="obj.logoURL" alt="Image" class="searchOrgimg img-fluid" />
            </span>
            <span class="searchOrgName" @click="searchOrgNavigation(obj)">{{obj.name}}</span>
            <span class="favOrgIcon">
              <img
                v-if="!(obj.isFavourite)"
                class="start-class"
                src="@/assets/star_normal.svg"
                @click="makeOrgFavOrUnFav(obj)"
                title="Mark as favourite"
              />
              <img
                v-if="obj.isFavourite"
                class="start-class"
                src="@/assets/star_active.svg"
                @click="makeOrgFavOrUnFav(obj)"
                title="Mark as un favourite"
              />
            </span>
          </li>
          <div
            class="your_favourites black-color"
            v-show="!filterOrgsData.length"
          >No Organisation Found</div>
        </ul>
        <tl-header type="h1"></tl-header>
        <button class="viewLess" @click="onViewLessOrganisationsClick()">View Less</button>
      </div>
    </div>
    <div class="welcome-text">
      <span id="greeting">{{getGreetings()}}</span>
      {{name}} !
    </div>
    <div class="search_org" v-show="showSearchBar">
      <input
        type="text"
        placeholder="Search Organisation Name"
        class="search_input"
        v-model="searchOrg"
        @keyup="getOrgs()"
      />
      <button type="button" class="searchOrgIcon">
        <i class="material-icons Icon">search</i>
      </button>
    </div>
    <div class="your_favourites">Your Organisations</div>
    <div class="container" v-show="!allOrganizationList" :disabled="!(ifSuperAdminPermission || ifTeamAnchorAuditorPermission)">
      <div class="row justify-content" v-if="favOrgs.length">
        <div
          class="flex-item"
          v-for="(obj,index) of favOrgs.slice(0,(favOrgs.length > 5) ? 4 : 5)"
          :key="index"
          @click="orgNavigate(obj)"
        >
          <a href="javascript:void(0)">
            <div class="logoimg">
              <img src="@/assets/org.svg" v-if="!obj.logoURL" class="Orgimg img-fluid" />
              <img :src="obj.logoURL" v-if="obj.logoURL" alt="Image" class="Orgimg img-fluid" />
            </div>
          </a>
          <a class="org_Name" :title="obj.name">{{obj.name}}</a>
        </div>

        <div class="flex-item-line" v-show="viewMoreOrgList">
          <span class="viewMore" @click="onViewMoreOrganisationsClick()">
            <span class="view_More_OrgText">
              <div class="line">View</div>
              <div class="line">More</div>
            </span>
          </span>
        </div>
      </div>
      <div v-else class="your_favourites">No Organisation Found</div>
    </div>
    <pop-up-window
              v-if="addAdminAccount && ifSuperAdmin"
              @back="addAdminAccount = !addAdminAccount"
              header="Create Admin Account">

              <template v-slot:content>
                <create-admin-account @back="addAdminAccount = !addAdminAccount"></create-admin-account>
              </template>

    </pop-up-window>
    
    <!-- Create User Account popup model -->
    <pop-up-window
      v-if="addUserAccount && ifSuperAdmin"
      @back="addUserAccount = !addUserAccount"
      header="Create User Account">
      <template v-slot:content>
        <create-user-account @back="addUserAccount = !addUserAccount"></create-user-account>
      </template>
    </pop-up-window>
    <!-- Create User Account End here  -->

    <!-- Permisson Access popup model -->
    <pop-up-window
      v-if="permissionAccessPopup && ifSuperAdmin"
      @back="permissionAccessPopup = !permissionAccessPopup"
      header="Permission Access">
      <template v-slot:content>
        <permission-access 
        @back="permissionAccessPopup = !permissionAccessPopup"
        :addUserValue="addUserValue || ifSuperAdmin"
        :addUserPermissionValue="addUserPermissionValue || ifSuperAdmin">
        </permission-access>
      </template>
    </pop-up-window>
    <!-- Permisson Access End here  -->

    <pop-up-message v-if="showSuccessMsg" :message="popupMessage" btnText="OK" @back="closeModal()"></pop-up-message>
    <pop-up-message
      v-if="showConfirmSignOut"
      :message="'Are you sure want to Signout ?'"
      :popupType="popupType"
      :popupHeaderMessage="'Confirm Signout'"
    >
      <template v-slot:bottomContent>
        <div class="popup-btn-group">
          <button class="btn-popup-secondary" type="button" @click="cancelEvent()">Cancel</button>
          <button class="btn-popup" type="button" @click="confirmSignout()">Signout</button>
        </div>
      </template>
    </pop-up-message>
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import CreateAdminAccount from "./signup.vue";
import PermissionAccess from "./permissionAccess.vue";
import CreateUserAccount from "./createUserAccount.vue";
export default {
  components: {
    CreateAdminAccount,
    PermissionAccess,
    CreateUserAccount
  },
  data() {
    return {
      showConfirmSignOut: false,
      popupType: "ConfirmDelete",
      showSuccessMsg: false,
      popupMessage: "",
      allOrganizationList: false,
      showSearchBar: false,
      viewMoreOrgList: false,
      searchOrg: "",
      favOrgs: [],
      filterOrgsData: [],
      toast: false,
      errmsg: "",
      addAdminAccount: false,
      permissionAccessPopup: false,
      addUserAccount: false,
      createOrganisationValue: false,
      addUserValue: false,
      addUserPermissionValue: false,
      organisationListValue: false,
      orgobject: null,
      role: ""
    };
  },
  mounted() {
    this.getGlobalData();
    this.getAllOrgs();
    let userRole = this.auth && this.auth.role
    if(userRole == 'CLIENTADMIN'){
      this.$router.push({path: `/clientOrgSummary`});
    } else if(userRole == 'EMPLOYEE' || userRole == 'HR'){
      this.$router.push({ path: `/dashboard/0/overview/feed` });
    }
    //this.getOrgLeIdList();
    //console.log("Auditor",this.ifAuditor);
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      name: state => state.auth.name,
      email: state => state.auth.email,
      globalData: state => state.globalapi.globalData,
    }),
    ...mapState("onboard/organization", {
      orgId: state => state.id,
    }),
    ifSuperAdmin() {
      return this.auth && this.auth.role == "SUPERADMIN" ? true : false;
    },
    ifTeamLeader() {
      return this.auth && this.auth.role == "TEAMLEADER" ? true : false;
    },
    ifAnchor() {
      return this.auth && this.auth.role == "ANCHOR" ? true : false;
    },
    ifAuditor() {
      return this.auth && this.auth.role == "AUDITOR" ? true : false;
    },
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ifSuperAdminPermission() {
      if(this.role === 'SUPERADMIN' || this.role === 'ADMIN') {
        // if(this.createOrganisationValue || this.organisationListValue) {
         return true;
        }  else {
        return false;
        }
      //  } else {
      //    return true;
      //  }
    },
    ifTeamAnchorAuditorPermission() {
      //console.log("User Role", this.role);
      if(this.role === 'TEAMLEADER' || this.role === 'ANCHOR' || this.role === 'AUDITOR') {
        if(this.organisationListValue) {
          return true;
        } else {
          return false;
        }
      }  
      // } else {
      //   return true;
      // }  
    },
    ifAdmin() {
      return this.auth && this.auth.role == "ADMIN" ? true : false;
    }
  },
  activated() {
    this.getGlobalData();
    this.getAllOrgs();
    //this.getOrgLeIdList();
  },
  methods: {
    ...mapActions({
      //Start PL-1959
      act_makeOrganisation_favourite_unFavourite:
        "onboard/organization/markOrganisationAsFavOrUnFav",
      //End PL-1959
      getFavouriteOrgs: "onboard/organization/fetchFavouriteOrg",
      getSearchOrgs: "onboard/organization/searchFavouriteOrg",
      act_setOrgId: "onboard/organization/changeOrgId",
      act_SetAuthOrgId: "auth/changeTheNewOrg",
      act_signOut: "auth/signOut",
      act_fetchglobalData: "globalapi/globalData/fetchAll",
      act_setOrgType: "onboard/organization/changeOrgType",
      getOrgLeList: "onboard/organization/getOrgLeIdList",
    }),

    /** To fetch Global data once */
    async getGlobalData() {
      try {
          const TAB_ID = Math.random().toString(36).slice(2)
         let heartbeat = {
        id: TAB_ID,
        timestamp: Date.now()
      };
      
      setInterval(() => {
        heartbeat.timestamp = Date.now(); // update timestamp
        localStorage.setItem("heartBeat", JSON.stringify(heartbeat));
        if(window.localStorage.getItem("loginId") && window.localStorage.getItem("loginId") !== this.email){
            if(window.localStorage.getItem("employeeId") && window.localStorage.getItem("employeeId") !== this.auth.employeeId){
              window.localStorage.clear()
            }
          }
      }, 1000); 
        
        if (!this.globalData.isGlobalDataFetched) {
          await this.act_fetchglobalData();
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    cancelEvent() {
      this.showConfirmSignOut = false;
    },

    /** Function to logged out a user */
    async confirmSignout() {
      try {
        let res = await this.act_signOut();
        if (res.status == 200) {
          this.$router.push({
            path: `/signin`
          });
          window.localStorage.clear();
          localStorage.removeItem("heartBeat")
          window.location.reload()
          window.sessionStorage.clear();
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    goToSignUp() {
      this.addAdminAccount = true;
      // this.$router.push({
      //   path: `/signup`
      // });
    },

    async signout() {
      this.showConfirmSignOut = true;
    },

    /** Function to view more organisations in UI */
    onViewMoreOrganisationsClick() {
      this.allOrganizationList = true;
      this.filterOrgsData = this.favOrgs;
    },

    /** Function to view less organisations in UI */
    onViewLessOrganisationsClick() {
      this.allOrganizationList = false;
    },

    /** Function to mark a organisation Favourite/UnFavourite */
    //Start PL-1959
    async makeOrgFavOrUnFav(obj) {
      try {
        let res = await this.act_makeOrganisation_favourite_unFavourite({
          data: {
            id: obj.id,
            name: obj.name,
            email: this.email,
            isFavourite: !obj.isFavourite
          }
        });

        if (res.data.status) {
          this.popupMessage = res.data.message;
          this.showSuccessMsg = true;
          /*
          obj.isFavourite = !obj.isFavourite;
          this.favOrgs = [...this.favOrgs];
          */
          /* To Fetch the list, re-arrange the order and to avoid issue of fetching fav org in OrgSummary screen */
          this.getAllOrgs();
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    closeModal() {
      this.showSuccessMsg = false;
    },

    //End PL-1959
    /** Function to show Greetings on UI */
    getGreetings() {
      try {
        let time = new Date().getHours();
        let wishing = "";
        if (time < 12) {
          wishing = "Good Morning";
        } else if (time < 16) {
          wishing = "Good Afternoon";
        } else {
          wishing = "Good Evening";
        }
        return wishing;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** On Add new Org click */
    onAddNewOrganisationClick() {
      this.act_setOrgId(null);
      this.$router.push({ path: "/onboarding/info" });
    },

    /** On Organisation click */
    orgNavigate(orgObj) {
      this.act_setOrgId(orgObj.id);
      this.act_SetAuthOrgId(orgObj.id);
      this.act_setOrgType(orgObj.isFavourite);
      this.$router.push({ path: "/orgsummary" });
    },

    /** To search a Organisation */
    searchOrgNavigation(orgNav) {
      this.act_setOrgId(orgNav.id);
      this.act_SetAuthOrgId(orgNav.id);
      this.act_setOrgType(orgNav.isFavourite);
      this.$router.push({ path: "/orgsummary" });
    },

    /** Function to fetch Organisations */
    async getOrgs() {
      try {
        let res = await this.getSearchOrgs(this.searchOrg);
        this.favOrgs = res.data.payload.data;
        if (!this.searchOrg) {
          this.sortOrgs(res.data.payload);
        }
        if (this.favOrgs.length < 5) {
          this.viewMoreOrgList = false;
        } else {
          this.viewMoreOrgList = true;
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /** TO set Organisations in sorting order of
     * 1. Favourite orgs should come first
     * 2. Next  remaining orgs
     */
    filterOrg(val) {
      try {
        let tempArray = [];
        this.favOrgs.forEach(element => {
          if (element.name) {
            if (element.name.toUpperCase().indexOf(val.toUpperCase()) > -1) {
              tempArray.push(element);
            }
          }
        });
        if (val) {
          this.filterOrgsData = tempArray;
        } else {
          this.filterOrgsData = this.favOrgs;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** To sort Organisations in the order of
     * 1. Favourite orgs should come first
     * 2. Next  remaining orgs
     */
    sortOrgs(Obj) {
      try {
        let allOrgs = Obj.data;
        let favoriteOrgs = Obj.favOrgs;
        let finalOrganisationsList = [];
        if (allOrgs.length) {
          allOrgs.forEach(item => {
            item["isFavourite"] = favoriteOrgs.some(
              favOrgObj => favOrgObj.id == item.id
            );
          });
        }
        if (allOrgs.length) {
          finalOrganisationsList = allOrgs.sort((a, b) => {
            return b.isFavourite - a.isFavourite;
          });
        }
        this.favOrgs = finalOrganisationsList.length
          ? finalOrganisationsList
          : [];
        this.filterOrgsData = finalOrganisationsList.length
          ? finalOrganisationsList
          : [];
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /** Function to fetch all organisations */
    async getAllOrgs() {
      try {
        let res = await this.getFavouriteOrgs();
        this.orgobject = res.data.user.organisations;
        this.getOrgLeIdList();

        /*** START: Show the organisation according to anchor user role */
        if (res.data.user) {
          //this.createOrganisationValue = res.data.user.permissions.create_organisation;
          if(res.data.user.userRole === 'ANCHOR') {
            if (res.data.payload.data.length > 0) {
              const organisations = res.data.payload.data;
              const permissionOrgs = res.data.user.organisations;
              let tempArray = [];
              organisations.forEach(element => {
                if (permissionOrgs[element['id']]) {
                  tempArray.push(element)
                }
              });
              res.data.payload.data = [];
              res.data.payload.data = tempArray;
            }
          }
        }

        // if (res.data.user) {
        //   if(res.data.user.userRole === 'ANCHOR') {
        //     if (res.data.payload.data.length > 0) {
        //       const organisations = res.data.payload.data;
        //       const permissionOrgs = res.data.user.organisations;
        //       let tempArray = [];
        //       organisations.forEach(element => {
        //         if (permissionOrgs[element['id']]) {
        //           tempArray.push(element)
        //         }
        //       });
        //       res.data.payload.data = [];
        //       res.data.payload.data = tempArray;
        //     }
        //   }
        // }
        /*** END: Show the organisation according to anchor user role */

        /*** START: To Differentiate an organisation is Fav or UnFav and Filtering the list ***/
        this.sortOrgs(res.data.payload);
        /*** END: To Differentiate an organisation is Fav or UnFav and Filtering the list ***/

        // End PL-1959
        if (res.data.payload.data.length > 5) {
          this.showSearchBar = true;
          this.viewMoreOrgList = true;
        } else {
          this.showSearchBar = false;
          this.viewMoreOrgList = false;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    permissionAcessFun() {
      this.permissionAccessPopup = true;
    },

    goToUserAccount() {
      this.addUserAccount = true;
    },

    async getOrgLeIdList() {
      let result = this.globalData;
      const org = this.orgId;
      const le = this.le_id;
      let bodyParams = this.orgobject; 
      //console.log("Data",bodyParams);
      let  data = await this.getOrgLeList({
        data: {
            ...bodyParams
          }
      });

      /*** START: Show the organisation according to anchor user role */
          if(data.data.user.userRole === 'SUPERADMIN' ||
          data.data.user.userRole === 'TEAMLEADER' ||
          data.data.user.userRole === 'ANCHOR' ||
          data.data.user.userRole === 'AUDITOR' ||
          data.data.user.userRole === 'ADMIN') {
            if (data.data.payload.data.length > 0) {
              let tempArray = [];
              data.data.payload.data.forEach(element => {
                //console.log("Element", element.Organisation.name);
                    tempArray.push(
                      {
                      id: element.Organisation.id,
                      name: element.Organisation.name,
                      logo: element.Organisation.logoURL,
                    });
              });
              //console.log("Temp Array", tempArray);

              let OrgList = tempArray.reduce((orgData, o) => {
                  if(!orgData.some(obj => obj.id === o.id && obj.name === o.name)) {
                    orgData.push(o);
                  }
                  return orgData;
              },[]);
              
              //res.data.payload.data = [];
              this.favOrgs = OrgList;
              //this.favOrgs = tempArray;
            }
          }
        
        /*** END: Show the organisation according to anchor user role */
      this.role = data.data.user.userRole;
      //{org_id:this.orgId, le_id:this.le_id}
      this.createOrganisationValue = data.data.user.permissions.create_organisation || this.ifSuperAdmin ? true : false;
      //If permisoin also given as superadmin 
      this.addUserValue = data.data.user.permissions.add_user || this.ifSuperAdmin ? true : false;
      this.addUserPermissionValue = data.data.user.permissions.add_user_permission || this.ifSuperAdmin ? true : false;
      //console.log("Check permission",this.addUserPermissionValue);
      this.organisationListValue = data.data.user.permissions.organisation_list || this.ifSuperAdmin ? true : false;
      //console.log("Org List",this.organisationListValue);
      //console.log("PL-3406",data);
     }
  },
};
</script>
<style lang="scss" scoped>
@import "../../../scss/animate.css";
@import "@/scss/_variables.scss";
@import "@/scss/dashboard/_variables.scss"; // variables

@keyframes move_wave {
  0% {
    transform: translateX(0) translateZ(0) scaleY(1);
  }
  50% {
    transform: translateX(-25%) translateZ(0) scaleY(0.55);
  }
  100% {
    transform: translateX(-50%) translateZ(0) scaleY(1);
  }
}
.waveWrapper {
  overflow: hidden;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: -1;
  margin: auto;
}
.waveWrapperInner {
  position: absolute;
  width: 100%;
  overflow: hidden;
  height: 100%;
  bottom: -1px;
  background-image: linear-gradient(239deg, #3ad0c3, #2ea7c2);
}
.bgTop {
  z-index: 15;
  opacity: 0.5;
  background: #34c0be;
}
.bgMiddle {
  z-index: 15;
  opacity: 0.75;
  background: #2ea7c2;
}
.bgBottom {
  z-index: 5;
  background: #3ad0c3;
}
.justify-content {
  justify-content: center;
  flex-wrap: nowrap;
}
.wave {
  position: absolute;
  left: 0;
  width: 200%;
  height: 100%;
  background-repeat: repeat no-repeat;
  background-position: 0 bottom;
  transform-origin: center bottom;
}
.searchOrgIcon {
  position: relative;
  outline: none;
  left: -40px;
  top: 10px;
}
.waveTop {
  background-size: 50% 100px;
  background-image: url("../../../assets/waves-top.png");
}
.waveAnimation {
  .waveTop {
    animation: move-wave 3s;
    -webkit-animation: move-wave 3s;
    -webkit-animation-delay: 1s;
    animation-delay: 1s;
  }
  .waveMiddle {
    animation: move_wave 10s linear infinite;
  }
  .waveBottom {
    animation: move_wave 15s linear infinite;
  }
}
.waveMiddle {
  background-size: 50% 120px;
  background-image: url("../../../assets/waves-middle.png");
}
.waveBottom {
  background-size: 50% 100px;
  background-image: url("../../../assets/waves-bottom.png");
}
.welcomeScreen {
  display: block;
}
.app-name {
  position: relative;
  float: left;
  margin: 62px 0px 0px 88px;
}
a {
  font-size: 36.8px;
  color: #ffffff;
  font-family: Montserrat;
  border-bottom: 2px inset #fdfdfdab;
  text-decoration: none;
}
.by-teamlease {
  width: 124px;
  height: 20px;
  font-family: Montserrat;
  font-size: 17px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}
.addNew {
  float: right;
  display: flex;
  margin: 79px 88px 0px 0px;
  position: relative;
  border: solid 2px #fff;
  border-radius: 4px;
  width: 123px;
  height: 35px;
}
.by-teamlease {
  width: 124px;
  height: 20px;
  font-family: Montserrat;
  font-size: 17px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}
.addNew {
  float: right;
  margin: 79px 88px 0px 0px;
  position: relative;
  border: solid 2px #fff;
  border-radius: 4px;
  width: auto;
  display: flex;
  height: 35px;
}
.signoutemp {
  img {
    float: right;
    margin: 79px -270px 0px 0px;
    position: relative;
    width: 32px;
    height: 32px;
    cursor: pointer;
  }
}
.paddingbottom {
  padding: 8px;
}
.add {
  float: left;
  padding-right: 10px;
}
/* Author: Vaishnavi
Date: 18/11/2019
Issue: Alignment of Add New and + icon
*/
.addNewOrg {
  font-size: 14px;
  font-weight: 600;
  display: flex;
  padding: 5px 5px 5px 2px;
  float: left;
  color: #ffffff;
  border-bottom: none;
  align-items: center;
  img {
    margin: 0 5px 0 5px;
  }
  span {
    font-size: 14px;
    font-weight: 600;
    margin-top: 1.5px;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #ffffff;
  }
}
.logo-name {
  width: 127px;
  height: 45px;
  font-family: Montserrat;
  font-size: 36.8px;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}

.welcome-text {
  text-align: center;
  padding-top: 60px;
  font-family: Montserrat;
  font-size: 40px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  clear: both;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
}
.search_org {
  text-align: center;
  form {
    button {
      position: relative;
      left: -60px;
      background: none;
      border: none;
      top: 10px;
    }
  }
}
.search_input {
  width: 614px;
  border: none;
  color: #9c9c9c;
  margin-top: 48px;
  font-size: 20px;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 3px 3px 11px 0 rgba(0, 0, 0, 0.2);
  background-color: #ffffff;
}
.Icon {
  color: #34c0be;
  font-size: 32px;
}
// start of PL-2277
.entity-container {
  width: auto;
  display: none;
  height: 155px;  // Ori: 145px
  box-shadow: 0 2px 20px 0 rgba(0, 0, 0, 0.15);
  background-color: #ffffff;
  border-radius: 6px;
  border: solid 0.8px #c6c9c8;
  position: absolute;
  right: 27px;
  z-index: 2;
  top: 110px;
  .entity-list {
    display: flex;
    height: 70%;
    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
      height: 50px;
      background-color: #666;
      border: 1px solid #eee;
      -webkit-border-radius: 6px;
    }
    img {
      margin: 18px;
    }
    .emp-details {
      margin: 32px 0 0 0;
      :first-child {
        font-family: Montserrat;
        font-size: 14px;
        font-weight: 600;
        color: #000000;
        margin-bottom: 8px;
      }
      font-family: Montserrat;
      font-size: 14px;
      color: #6e6e6e;
    }
  }
  .signoutdiv {
    width: auto;
    height: 42px;
    border-radius: 6px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    background-color: #f8f8f8;
    color: #34c0be;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    color: #34c0be;
    margin-left: -1px;
    .btn-settings {
      margin-left: 60px;
      margin-top: 12px;
      cursor: pointer;
    }
    .btn-signout {
      margin-left: 60px;
      margin-right: 20px;
      margin-top: 12px;
      cursor: pointer;
    }
  }
  .divider {
    border-left: 1px solid #dddddd;
    height: 42px;
    margin-left: 50px;
  }
}
.entity-container::before {
  bottom: 100%;
  right: 10px;
  border: 0.8px solid #c6c9c8;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
  border-color: transparent;
  border-bottom-color: $color-white;
  border-width: 4px 10px 8px 10px;
}
.signoutemp {
  cursor: pointer;
  .entity-container {
    display: none;
   // margin-top: 10px;
  }
  &:hover {
    .entity-container {
      padding:10px;
      display: block;
    }
  }
}
//end of PL-2277
.your_favourites {
  font-family: Montserrat;
  font-size: 24px;
  font-weight: normal;
  text-align: center;
  font-style: normal;
  font-stretch: normal;
  display: block;
  line-height: normal;
  letter-spacing: normal;
  color: #ffffff;
  margin: 0 auto;
  padding-top: 90px;
  padding-bottom: 48px;
}
.organisations {
  border-radius: 50%;
  max-height: 150px;
  width: 150px;
  display: block;
  margin: 0 auto;
  object-fit: cover;
}
.flex-item {
  width: 200px;
  min-height: 200px;
  background: #fff;
  border-radius: 6px;
  display: block;
  cursor: pointer;
  transition: box-shadow 0.3s ease-out, transform 0.3s ease-out,
    opacity 0.2s ease-out;
  overflow: hidden;
  box-shadow: 3px 3px 11px 0 rgba(0, 0, 0, 0.2);
  margin-right: 68px;
}
.flex-item-line {
  width: 200px;
  min-height: 200px;
  background: #fff;
  border-radius: 6px;
  display: block;
  cursor: pointer;
  transition: box-shadow 0.3s ease-out, transform 0.3s ease-out,
    opacity 0.2s ease-out;
  overflow: hidden;
  box-shadow: 3px 3px 11px 0 rgba(0, 0, 0, 0.2);
  margin-right: 68px;
}
.flex-item:hover {
  border-radius: 6px;
  transition: margin 0.9s;
  margin-top: -1px;
  transition-delay: 0.1s;
  transition: box-shadow 0.3s ease-out, transform 0.3s ease-out,
    opacity 0.2s ease-out;
  margin-bottom: 1px;
  opacity: 1 !important;
  box-shadow: rgba(45, 45, 45, 0.05) 0px 2px 2px,
    rgba(49, 49, 49, 0.05) 0px 4px 4px, rgba(42, 42, 42, 0.05) 0px 8px 8px,
    rgba(32, 32, 32, 0.05) 0px 16px 16px, rgba(49, 49, 49, 0.05) 0px 32px 32px,
    rgba(35, 35, 35, 0.05) 0px 64px 64px;
  transform: translate(0, -4px);
  z-index: 0;
}
.flex-item-line:hover {
  border-radius: 6px;
  transition: margin 0.9s;
  margin-top: -1px;
  transition-delay: 0.1s;
  transition: box-shadow 0.3s ease-out, transform 0.3s ease-out,
    opacity 0.2s ease-out;
  margin-bottom: 1px;
  opacity: 1 !important;
  box-shadow: rgba(45, 45, 45, 0.05) 0px 2px 2px,
    rgba(49, 49, 49, 0.05) 0px 4px 4px, rgba(42, 42, 42, 0.05) 0px 8px 8px,
    rgba(32, 32, 32, 0.05) 0px 16px 16px, rgba(49, 49, 49, 0.05) 0px 32px 32px,
    rgba(35, 35, 35, 0.05) 0px 64px 64px;
  transform: translate(0, -4px);
  z-index: 0;
  .line {
    border-bottom: 2px solid #34c0be;
  }
}
.org_Name {
  font-family: Montserrat;
  font-size: 20px;
  font-weight: 600;
  padding: 0px 10px 15px 10px;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #000000;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.noOrgImage {
  border: solid 1px #cdcdcd;
  width: 100%;
  height: 100%;
  -o-object-fit: contain;
  object-fit: contain;
  padding: 0px 10px;
  word-break: break-all;
}
.searchOrgimg {
  width: 100px;
  float: left;
  object-fit: contain;
  height: 70px;
  line-height: 70px;
}
.logoimg {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  margin: 0 auto;
  overflow: hidden;
  width: 64px;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  height: 64px;
  margin-top: 36px;
  margin-bottom: 16px;
}
.Orgimg {
  width: 100%;
  height: 100%;
  object-fit: contain;
  padding: 0px 0px;
  word-break: break-all;
}
.Orgimg:hover {
  border-radius: 0px;
}
.org_Name:hover {
  border-radius: 0px;
}
.view_More_OrgText {
  width: 53px;
  float: left;
  line-height: 25px;
  height: 200px;
  position: relative;
  left: 35%;
  padding-top: 71px;
}

.view_More_OrgText:hover {
  width: 53px;
  float: left;
  line-height: 25px;
  height: 200px;
  position: relative;
  left: 35%;
  padding-top: 71px;

  .line {
    border-bottom: 2px solid #34c0be;
  }
}
.viewMore {
  text-align: center;
  display: block;
  font-size: 20px;
  font-weight: bold;
  color: #34c0be;
  line-height: 200px;
}
.orgDetails li {
  list-style-type: none;
  width: 100%;
  margin-left: 0px;
  margin-right: 30px;
  margin: 10px 0px;
  cursor: pointer;
  padding: 10px;
}
.orgDetails li:hover {
  border-radius: 10px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.2);
  background: #f6f6f6;
  line-height: 70px;
}
.orgDetails {
  margin: 10px 0px;
  line-height: 70px;
  width: 100%;
  max-height: 420px;
  float: left;
  overflow-y: scroll;
  padding-left: 0px;
  min-height: 415px;
}
.allOrganizations {
  background: #fff;
  width: 100%;
  float: left;
  margin-top: 30px;
  z-index: 1;
  border-radius: 10px;
  padding: 20px;
  position: absolute;
  box-shadow: 3px 3px 11px 0 rgba(0, 0, 0, 0.2);
}
.favOrgIcon {
  float: right !important;
  padding-right: 20px;
}
.searchOrgName {
  font-weight: bold;
}
.viewLess {
  float: right;
  padding: 10px 30px;
  width: 205px;
  height: 45px;
  color: #34c0be;
  font-weight: bold;
  border-radius: 4px;
  box-shadow: 2px 2px 8px 0 rgba(0, 0, 0, 0.1);
  border: solid 2px #37c6c0;
}
.viewAllImg {
  width: 100px;
  object-fit: contain;
  line-height: 70px;
  margin-left: 0px;
  margin-right: 30px;
}
.margin_space {
  margin: 0% 4.5%;
  position: relative;
  top: 120px;
}
.animated {
  animation-duration: 0.5s;
  -webkit-animation-duration: 0.5s;
  animation-fill-mode: both;
  -webkit-animation-fill-mode: both;
}
.black-color {
  color: black !important;
}

// Permission Access text apply css
.permission-text {
  font-size: 0.9rem;
  font-weight: 600;
  color: black;
  margin: 3px 0px;
}
</style>
